export default __webpack_public_path__ + "static/media/Flaticon.ca86721f.woff";